export function throwFallible(graphqlErrors, payloadErrors, overrideCodes = {}) {
    const errors = [];
    const unknownMessage = 'An unknown error occurred';
    const unknownCode = 'UnknownError';
    if (graphqlErrors) {
        graphqlErrors.forEach((e) => {
            errors.push({ __typename: 'PayloadError', code: 'GraphQLError', message: e.message || unknownMessage });
        });
    }
    if (payloadErrors) {
        payloadErrors.forEach((e) => {
            if (!e)
                return;
            errors.push({ __typename: 'PayloadError', code: e.code || unknownCode, message: e.message || unknownMessage });
        });
    }
    if (errors.length) {
        const error = errors.map((e) => {
            const { message, code } = e;
            return overrideCodes[code || unknownCode] || message;
        }).join('\n');
        throw new Error(error);
    }
}
